// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3vlOhcSxmMsGyizeoMrSNF{display:flex;flex-direction:column}.UvsGqoYJx-M6EpnvTdYMO{margin-bottom:.4rem}._1aeOjaBKJ4CsubjgCDoSMm{margin-top:.8rem;color:#555}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_3vlOhcSxmMsGyizeoMrSNF",
	"name": "UvsGqoYJx-M6EpnvTdYMO",
	"date": "_1aeOjaBKJ4CsubjgCDoSMm"
};
module.exports = ___CSS_LOADER_EXPORT___;
